import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useSession } from "0.Mine/2.Context/sessionContext";
import { Customer } from "0.Mine/3.Interfaces/customer";
import { CustomerDetails } from "0.Mine/3.Interfaces/customerDetails";
import axiosInstance from "0.Mine/axiosInstance";

import { QlickupActions, useQlickupAPI } from "../APICall";

export const UseHandleCustomers = () => {
  const navigate = useNavigate();
  const { session } = useSession();
  const { QlickUpAPI } = useQlickupAPI();
  useEffect(() => {
    if (!session) {
      navigate("/signin", { replace: true });
    }
    if (!session?.user) {
      navigate("/signin", { replace: true });
    }
  });

  const getOneCustomerDetails = async (businessid: number, clientId: number) => {
    const userid = session.user.id;
    const token = session.user.token;
    const payloadForQuery: Record<string, string> = {
      userid: userid,
      token: token ?? "",
      businessid: businessid.toString() ?? "",
      clientid: clientId.toString() ?? "",
      action: "getone",
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/customerlog.php?${queryString}`);

      console.log("RESPONSE PORCODIO", response);

      if (response.status === 200) {
        return response.data as CustomerDetails;
      } else {
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getAllCustomers = async (businessId: number) => {
    const userid = session.user.id;
    const token = session.user.token;
    const payloadForQuery: Record<string, string> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId.toString() ?? "",
      action: "getall",
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/customerlog.php?${queryString}`);

      console.log("RESPONSE PORCODIO", response);

      if (response.status === 200) {
        return response.data as Customer[];
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const cancelBooking = async (businessId: number, bookingId: number) => {
    const userid = session.user.id;
    const token = session.user.token;

    const payload = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      bookingid: bookingId,
      action: "cancel",
    };

    try {
      const response = await axiosInstance.post(`POST/booking.php`, payload);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  const sendReminderForBusiness = async (businessId: number, reminders: string[]) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "reminder",
      reminders,
      "booking",
      QlickupActions.POST
    );
    console.log(response);
  };

  const getRemindersForBusiness = async (businessId: number) => {
    const response = await QlickUpAPI(
      businessId.toString(),
      "reminder",
      null,
      "booking",
      QlickupActions.GET
    );
    console.log("BOOKING RESPONSE: ", response.data);
    return response.data as string[];
  };

  return {
    getAllCustomers,
    getOneCustomerDetails,
    cancelBooking,
    sendReminderForBusiness,
    getRemindersForBusiness,
  };
};
